/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyModel } from '../../models/client-survey-model';

export interface GetSurveys$Plain$Params {

/**
 * case id of surveys to return
 */
  caseId: number;

/**
 * id of surveytype for filter
 */
  surveyTypeId?: number;

/**
 * number of records to skip. default 0
 */
  skip?: number;

/**
 * number of records to take. default 20
 */
  take?: number;
}

export function getSurveys$Plain(http: HttpClient, rootUrl: string, params: GetSurveys$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyModel>>> {
  const rb = new RequestBuilder(rootUrl, getSurveys$Plain.PATH, 'get');
  if (params) {
    rb.query('caseId', params.caseId, {});
    rb.query('surveyTypeId', params.surveyTypeId, {});
    rb.query('skip', params.skip, {});
    rb.query('take', params.take, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientSurveyModel>>;
    })
  );
}

getSurveys$Plain.PATH = '/api/Survey';
